import { createRouter, createWebHistory } from 'vue-router'
import { isRouteEnabled } from '@/services/navigation/navigationConfigService'

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/default/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/pages/home/HomePage.vue')
      },
      {
        path: 'about-us',
        name: 'AboutUs',
        component: () => import('@/pages/about/AboutUsPage.vue')
      },
      {
        path: 'termine',
        name: 'Termine',
        component: () => import('@/pages/termine/TerminePage.vue')
      },
      {
        path: 'mitglieder',
        children: [
          {
            path: '',
            name: 'Mitglieder',
            component: () => import('@/pages/members/MembersPage.vue')
          },
          {
            path: ':name',
            name: 'Mitglied',
            component: () => import('@/pages/members/MemberDetailPage.vue')
          }
        ]
      },
      {
        path: 'handwerk',
        children: [
          {
            path: '',
            name: 'Handwerk',
            component: () => import('@/pages/handwerk/HandwerkPage.vue')
          },
          {
            path: ':slug',
            name: 'HandwerkDetail',
            component: () => import('@/pages/handwerk/HandwerkDetailPage.vue')
          }
        ]
      },
      {
        path: 'geschichte',
        name: 'Geschichte',
        component: () => import('@/pages/history/HistoryPage.vue')
      },
      {
        path: 'impressum',
        name: 'Impressum',
        component: () => import('@/pages/imprint/ImpressumPage.vue')
      },
      {
        path: 'datenschutz',
        name: 'Datenschutz',
        component: () => import('@/pages/privacy/PrivacyPolicyPage.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/pages/not-found/NotFoundPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return { ...savedPosition, behavior: 'smooth' }
    } else {
      return { top: 0, left: 0, behavior: 'smooth' }
    }
  }
})

// Redirect disabled routes to 404
router.beforeEach((to) => {
  const routeName = to.name as string
  if (routeName && !isRouteEnabled(routeName)) {
    return { name: 'NotFound' }
  }
})

export default router
